import React from 'react';
import ServiceDetail from '../components/ServiceDetail';
import PageSeo from '../components/shared/PageSeo';

const ServiceDetailPage = ({ service }) => (
  <>
    <PageSeo
      title={service.seoTitle}
      description={service.seoDescription}
      path={`/service/${service.slug}`}
      serviceName={service.title}
    />
    <ServiceDetail service={service} />
  </>
);

export default ServiceDetailPage;
